import { render, staticRenderFns } from "./companyPage.vue?vue&type=template&id=3b76a158&scoped=true"
import script from "./companyPage.vue?vue&type=script&lang=js"
export * from "./companyPage.vue?vue&type=script&lang=js"
import style0 from "./companyPage.vue?vue&type=style&index=0&id=3b76a158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76a158",
  null
  
)

export default component.exports